import { useEffect, useState } from 'react';

/**
 * Хук для оптимизации отправки многократно повторяющихся запросов
 * Обновляет отправляемое на сервер значение, если на протяжении заданного
 * временного интервала не было зарегистрировано его изменение из интерфейса
 * @param value Обновляемое из интерфейса значение
 * @param delay Интервал наблюдения, мс
 */

function useDebounce<T>(value: T, delay: number) {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => {
      clearTimeout(handler);
    };
  }, [value]);

  return debouncedValue;
}

export default useDebounce;
